///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance = abcsetup.front_store.maintenance || {};
abcsetup.front_store.maintenance.workflow = abcsetup.front_store.maintenance.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.task = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance.workflow = {
    init: function () {
        $("html, body").scrollTop(0);
        abcsetup.setTitle('Update Consumer Item Maintenance');

        // Assign local vars
        abcsetup.item = JSON.parse($('form.front-store-item #item_object').html());
        abcsetup.task = JSON.parse($('form.front-store-item #current_task').html());

        // Disable the approve button when rejecting
        $('#reject-btn-dropdown').on('shown.bs.dropdown', function () {
            $('div.right .buttons .btn-approve').attr('disabled', true);
        }).on('hidden.bs.dropdown', function () {
            $('div.right .buttons .btn-approve').attr('disabled', false);
        });

        // Item details accordion
        $("#nav-details .collapse").on('show.bs.collapse', function () {
            $(this).parent().parent().find('.collapse.show').collapse('hide');
        });

        // Set up default fields to help with showIf and requireIf behavior
        abcsetup.form_manager.form = $('form.front-store-item');
        abcsetup.form_manager.setAndCreate();
        this._setMaintenanceValues();

        // Bind the reject dropdown events
        this._bindRejectDropdown();

        // Bind the search details input field
        this._bindDetailsSearch();

        // Init item history datatable
        abcsetup.datatables.client_side.init($('#item_history'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[1, 'asc']],
            'responsive': false,
        });

        // Init the duplicate items datatable
        abcsetup.datatables.client_side.init($('#duplicate_table'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[1, 'asc']],
            'responsive': false,
            //'ordering': false,
        });

        // Apply slim scroll
        var height = $(window).height() - $('div.tab-content').offset().top - 30;
        if (height < 300) {
            height = 300;
        }

        $('div.right div.tab-content').slimScroll({
            height: height,
            position: 'right',
            railVisible: true,
            alwaysVisible: true
        });

        // Check for duplicates
        if ($('#duplicate_check').length) {
            this._checkForDuplicates();
        }

        // Reject button clicked
        $('#reject-btn').on('click', function () {
            abcsetup.front_store.maintenance.workflow._rejectItem();
        });

        $(document).on('click', 'button[name="cancel_maintenance"]', function (event) {
            event.preventDefault();
            var _this = $(this);
            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you would like to cancel maintenance?', function (resp) {
                if (resp) {
                    abcsetup.form_manager.form.append("<input type='hidden' name='form_action' value='cancel_maintenance'>");
                    abcsetup.form_manager.form.submit();
                }
            });
            // <button type="submit" name="form_action" value="cancel_maintenance" class="btn btn-warning  button cancel_maintenance mr-3" formnovalidate>Cancel Maintenance</button>
        });

        const checkFormValidity = form => {
            $(form).find('.accordion .collapse').collapse('show'); // Open all accordions, so all visible fields are visible (we can't currently just pull all fields regardless of visibility. some are hidden because they're in a hidden accordion panel. others are hidden even when the panel is visible.)

            const isValid = fieldValidate.checkValidity(form);

            // We can't do this immediately. I think because the expand animation for the accordion hasn't finished yet when we get here.
            window.setTimeout(() => $(form).find('.accordion .collapse:not(:has(:invalid))').collapse('hide'), 400);

            return isValid;
        };

        // Validate each visible required field
        $('.btn-validator').on('click', function () {
            if (checkFormValidity($(this).closest('form'))) {
                abcsetup.alerts.show('Form Validation', 'All fields on this tab have passed validation');
            } else {
                $('.invalid:visible:first').trigger('focus');
                abcsetup.alerts.show('Form Validation', 'There are errors on this tab. Please review the fields highlighted in red');
            }
        });

        $('#maintenance_submit').on('click', function (event) {
            if (!checkFormValidity($(this).closest('form'))) {
                event.preventDefault();
                abcsetup.alerts.show('Form Validation', 'There are errors in this form. Please review the fields highlighted in red');
            }
        });

        // Approve button clicked
        $('.btn-approve').on('click', function () {
            abcsetup.front_store.maintenance.workflow._takeScreenShot();
        });

        // Maintenance History button clicked
        $(document).on('click', ".maintenance_history", function () {
            $(this).css("cursor", "progress");
            abcsetup.abc_item.index.item_id = $(this).data("entity-id");

            axios.get('/api/abc_item/maintenance_history/' + abcsetup.abc_item.index.item_id).then(response => {
                $(this).css("cursor", "pointer");
                $(response.data).modal('show');
            });
        });
    },

    /**
     * _jquery.fieldLib hase been init - this is the callback
     */
    fieldsInit: function () {
        // Init any field restrictions/values
        this._initFields();

        // Init the SAP Div
        this._initSAPDiv();

        // Init the attachments
        this._initAttachments();
    },

    /**
     * Set the Maintained field values
     */
    _setMaintenanceValues: function() {
        /*CurrentTask->WorkflowInit->ItemMaintenance*/
        for (var i in abcsetup.task.workflow_init.item_maintenance) {
            if (abcsetup.task.workflow_init.item_maintenance[i] !== null) {
                abcsetup.form_manager._setFieldValue(abcsetup.task.workflow_init.item_maintenance[i].col, JSON.parse(abcsetup.task.workflow_init.item_maintenance[i].new_val));
                // Update the item object to contain the new maintained values
                // This fixes any DOT / IATA rendering issues
                abcsetup.item[abcsetup.task.workflow_init.item_maintenance[i].col] = JSON.parse(abcsetup.task.workflow_init.item_maintenance[i].new_val);
            }
        };
    },

    /**
     * Bind the reject dropdown events
     */
    _bindRejectDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', '.dropdown-menu.reject input.checkbox', function () {
            if ($(this).prop('checked')) {
                $(this).closest('div.checkbox').find('textarea').show();
            } else {
                $(this).closest('div.checkbox').find('textarea').hide().next('.errorMsg').remove();
            }
        });
    },


    /**
     * Bind the search details input field
     */
    _bindDetailsSearch: function () {
        // The search field had a key pressed
        $("#nav-details").find("#details-search").on("keyup", function (e) {
            var code = e.which;
            var value = $(this).val().toLowerCase();

            if (value) {
                // Filter down the sections to what was typed
                $("#nav-details .item-details, #nav-details .item-details h5").filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                });

                $("#nav-details .item-details:visible").find('.collapse').addClass('show');
                $("#nav-details .item-details h5").unhighlight().highlight(value);

            } else {
                // Clear search results and show all
                $("#nav-details .item-details, #nav-details .item-details h5").show();
                $("#nav-details .item-details:visible").find('.collapse').removeClass('show');
                $("#nav-details .item-details h5").unhighlight();
            }
        });

        // Expand/Collapse All
        $("#nav-details").find("#toggle_all").on("click", function (e) {
            $(this).blur().parent().parent().find('.collapse').collapse('toggle');
        });
    },


    /**
     * Check for duplicates
     */
    _checkForDuplicates: function () {
        var approve_btn = $('div.right .buttons .btn-approve');
        approve_btn.attr('disabled', true);

        axios.get('/api/front_store/duplicate_check/' + abcsetup.item.id).then(response => {
            approve_btn.attr('disabled', false);
            //alert(JSON.stringify(response.data.existing_item_record.length));

            if (response.data.error) {
                $("#duplicate_check").removeClass('alert-warning').addClass('alert-danger').html('Error querying Enterprise database');

            } else if (response.data.existing_item_record.length) {
                $('#duplicate_check').addClass('warning').html('<h5 class="mb-0">Duplicate item(s) exists in the Enterprise database:</h5><br>');

                $(response.data.existing_item_record).each(function () {
                    $('#duplicate_check').addClass('warning').append('<b>eMAT ID</b> : ' + (this.emat_id ? this.emat_id : '') + ' | ' +
                        '<b>SAP #</b> : ' + (this.sap_num ? this.sap_num : '') + ' | ' +
                        '<b>MAT. STATUS</b> : ' + (this.mat_status ? this.mat_status : '') + ' | ' +
                        '<b>MAT. TYPE</b> : ' + (this.mat_type ? this.mat_type : '') + ' | ' +
                        '<b>MAT. GROUP</b> : ' + (this.mat_group ? this.mat_group : '') + ' <br> ' +
                        '<b>MAT. DESCR.</b> : ' + (this.mat_descr ? this.mat_descr : '') + '<hr>');
                });

                approve_btn.append('<i class="fas fa-exclamation-circle text-caution ml-2"></i>');
                approve_btn.attr('title', 'Click to Approve item with duplicate identifiers').tooltip();

            } else {
                $('#duplicate_check').removeClass('alert-warning').addClass('alert-success').html('No duplicate items were found in the Enterprise database.');
            }
        });
    },


    /**
     * Reject the item
     */
    _rejectItem: function () {
        let error = false;
        const checkedItems = $('.dropdown-menu.reject input:checkbox:checked');

        //Click to Reject item
        if (checkedItems.length === 0) {
            abcsetup.alerts.show('Reject Error', 'Please select at least 1 reason to reject the item');
            return false;
        }

        // Validate the rejection reasons
        checkedItems.each(function () {
            const rejectReasonField = $('textarea[name="reject_reason_text[' + $(this).attr('value') + ']"].required');
            if (rejectReasonField.length > 0 && !rejectReasonField.val()) {
                error = true;
                rejectReasonField.addClass('error');
            }
        });

        if (error) {
            return false;
        }

        $('#reject-btn').unbind('click').attr('type', 'submit').trigger('click');
    },


    /**
     * Init any field restrictions/values
     */
    /**
     * Init any field restrictions/values
     */
    _initFields: function () {
        require('./_common_rules');
    },

    ndc10_to_ndc11: function (ndc10, ndc10_format) {
        var ndc11 = "";
        switch (ndc10_format) {
            case "4-4-2":
                ndc11 = "0" + ndc10.replace(/\-/g, "");
                break;
            case "5-3-2":
                ndc11 = ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2);
                break;
            case "5-4-1":
                ndc11 = ndc10.substr(0, 5) + ndc10.substr(6, 4) + "0" + ndc10.substr(11, 1);
                break;
        }
        console.log('ndc10_to_ndc11[' + ndc10_format + ']: [' + ndc10 + ']->[' + ndc11 + ']');
        return ndc11;
    },
    /**
     * Init the attachment buttons
     */
    _initAttachments: function () {
        // var attachment_types = JSON.parse($('#attachments .uploader-container').html());
        // var item_type = $('#type').val();

        // $('#attachments .uploader-container').empty();

        // $(attachment_types).each(function() {
        //     if ($.inArray(this.idx, abcsetup.rx_item.maintenance.hideButtons) == -1 && (this.no_upload == 0)) {
        //         // Build the upload buttons, but keep them hidden
        //         abcsetup.uploader.buildUploaderButton(this, function(button) {
        //             $('#attachments .uploader-container').append(button);
        //         });
        //     }
        // });

        // $("button#fda_waiver").removeClass("required btn-danger").hide();
        // $("button#spec_sheet").removeClass("required btn-danger").hide();
        // $("button#msds_sheet").removeClass("required btn-danger").hide();
        // $("button#case_label").removeClass("required btn-danger").hide();
        // $("button#pr_registration_doc").removeClass("required btn-danger").hide();
        // $("button#front_panel_product_image").removeClass("required btn-danger").hide();
        // $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        // $("button#hda_form").removeClass("required btn-danger").hide();
        // $("button#prescribing_information_attachment").removeClass("required btn-danger").hide();
        // $("button#short_dated_offer_letter").removeClass("required btn-danger").hide();

        const buttonsToRemove = [
            'fda_waiver',
            // 'spec_sheet',
            // 'sds_waiver',
            // 'msds_sheet',
            'case_label',
            // 'pr_registration_doc',
            // 'front_panel_product_image',
            'flat_product_bar_code_image',
            'hda_form',
            'prescribing_information_attachment',
            'short_dated_offer_letter',
            'maintenance_approve_screenshot',
            'outside_shipping_carton_label',
            'sap_pricing_letter',
            'ahp_pricing_letter',
            'mwi_pricing_letter'
        ];

        buttonsToRemove.forEach(attachmentTypeId => {
            $('button#' + attachmentTypeId).remove();
            $('input[data-idx="' + attachmentTypeId + '"]').remove();
        });

        // Manually apply showIf rules to buttons and their input fields
        $('button#sds_waiver, input[data-idx="sds_waiver"]').attr('showIf', 'sds_waiver=N');
        abcsetup.fieldLib.bindElement($('button#sds_waiver, input[data-idx="sds_waiver"]'), 'showIf');

        $('button#msds_sheet, input[data-idx="msds_sheet"]').attr('showIf', 'sds_waiver=Y');
        abcsetup.fieldLib.bindElement($('button#msds_sheet, input[data-idx="msds_sheet"]'), 'showIf');

        $('button#pr_registration_doc, input[data-idx="pr_registration_doc"]').attr('showIf', 'pr_registration=Y|eligible_sale_pr=Y');
        abcsetup.fieldLib.bindElement($('button#pr_registration_doc, input[data-idx="pr_registration_doc"]'), 'showIf');

        // Even if an item already has an SDS sheet if they change the values of certain fields they need to upload a new one
        // $(abcsetup.item.attachments).each(function() {
        //     console.log('type->'+this.type);
        //     abcsetup.rx_item.maintenance.removeButtons.push(this.type);
        //     $('button#'+this.type).removeClass('required btn-danger').hide();
        // });
    },

    _initSAPDiv: function () {
        require('../_sap_divisions');
    },

    /**
     * Take a screen shot of the screen before approving
     */
    _takeScreenShot: function () {
        $("footer, #abcsetup-navbar").hide();

        html2canvas(document.getElementsByTagName('body')[0], {scale: 1}).then(canvas => {
            canvas.id = "canvasID";

            var mainWrapper = $('#main-wrapper').clone();
            var main = mainWrapper[0];

            while (main.firstChild) {
                main.removeChild(main.firstChild);
            }

            main.appendChild(canvas);

            var image_url = mainWrapper.find('#canvasID')[0].toDataURL();
            var base64_image = image_url.replace(/^data:image.+;base64,/, '');

            $("footer, #abcsetup-navbar").show();
            $("#screenshot_base64").val(base64_image);
            $('#hidden_approve_btn').trigger('click');
        });
    },

    uploadDoneAfterAutoAppend() {
        if (abcsetup.uploader.button.closest('#images_tab').length > 0 && $(abcsetup.uploader.button).data('type') !== 'glamour_shot') {
            $(abcsetup.uploader.button)
                .closest('.attachments')
                .find('.attachment-link-thumb')
                .removeClass(['col-12', 'col-md-3'])
                .addClass('col');
        }

        var mfg_part_num = $('#mfg_part_num').val();
        var case_ean = $('#case_ean').val();
        var inner_ean = $('#inner_ean').val();
        if ($(abcsetup.uploader.button).data('type') == 'flat_product_bar_code_image' &&
            (mfg_part_num != abcsetup.item.mfg_part_num ||
                case_ean != abcsetup.item.case_ean ||
                inner_ean != abcsetup.item.inner_ean
            )
        ) {
            $("button#spec_sheet").removeClass("required btn-danger");
        }

        if ($(abcsetup.uploader.button).data('type') == 'spec_sheet' &&
            (mfg_part_num != abcsetup.item.mfg_part_num ||
                case_ean != abcsetup.item.case_ean ||
                inner_ean != abcsetup.item.inner_ean
            )
        ) {
            $("button#flat_product_bar_code_image").removeClass("required btn-danger");
        }
    },
}
